import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfiguratorRenewalInformation } from '@models';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';
import { environment } from '@environments/environment';

export interface PostRenewalInformationParams extends DefaultHttpHeaders {}

@Injectable()
export class PostRenewalInformationService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }
  postRenewalInformation(
    body: ConfiguratorRenewalInformation,
    params: PostRenewalInformationParams
  ): Observable<ConfiguratorRenewalInformation> {
    return this.post<ConfiguratorRenewalInformation, ConfiguratorRenewalInformation>({
      suffix: '/configurator/policy/renewal/information',
      apiUrl: environment.configuratorApiUrl,
      body,
    });
  }
}
